import React from 'react';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, } from '@cargomatic/ui';
import { useTranslation } from 'react-i18next';
export function ConfirmationModal({ title, description, open = false, onHide, onConfirm, cancelText, confirmText, }) {
    const { t } = useTranslation();
    return (React.createElement(AlertDialog, { open: open, onOpenChange: onHide },
        React.createElement(AlertDialogContent, null,
            React.createElement(AlertDialogHeader, null,
                React.createElement(AlertDialogTitle, null, title),
                description && (React.createElement(AlertDialogDescription, null, description))),
            React.createElement(AlertDialogFooter, null,
                React.createElement(AlertDialogCancel, null, cancelText || t('CANCEL')),
                React.createElement(AlertDialogAction, { onClick: onConfirm }, confirmText || t('CONFIRM'))))));
}
